import { useState, useEffect, useRef } from "react";
import {
  GoogleMap,
  Marker,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultCenter = {
  lat: 28.6139,
  lng: 77.209,
};

function MapWithDraggableMarker({ location, setState }) {
  const [center, setCenter] = useState(
    location
      ? typeof location === "string"
        ? JSON.parse(location)
        : location
      : defaultCenter
  );
  const [markerPosition, setMarkerPosition] = useState(null);
  const autocompleteRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCe9oT2jf6jTnEOTbcJ0a9tg53WIT90aJg", // Replace with your API key
    libraries: ["places"],
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setCenter(pos);
        setMarkerPosition(pos);
        reverseGeocode(pos);
      });
    }
  }, []);

  const reverseGeocode = async (latlng) => {
    if (window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK" && results[0]) {
          const components = results[0].address_components;
          const country = components.find((c) =>
            c.types.includes("country")
          )?.long_name;
          const state = components.find((c) =>
            c.types.includes("administrative_area_level_1")
          )?.long_name;
          const city = components.find((c) =>
            c.types.includes("locality")
          )?.long_name;
          const area = components.find((c) =>
            c.types.includes("sublocality")
          )?.long_name;
          const pincode = components.find((c) =>
            c.types.includes("postal_code")
          )?.long_name;
          const premise = components.find((c) =>
            c.types.includes("premise")
          )?.long_name;

          setState({
            addressLine1: `${premise || ""}`,
            addressLine2: `${area || ""}`,
            city,
            state,
            country,
            pincode,
            location: latlng,
          });
        }
      });
    }
  };

  const onPlaceChanged = () => {
    console.log("onPlaceChanged");
    const place = autocompleteRef.current.getPlace();
    if (!place || !place.geometry) return;

    const pos = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    setCenter(pos);
    setMarkerPosition(pos);
    reverseGeocode(pos);
  };

  const onMapClick = (e) => {
    const pos = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setMarkerPosition(pos);
    reverseGeocode(pos);
  };

  const onMarkerDragEnd = (e) => {
    const pos = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setMarkerPosition(pos);
    reverseGeocode(pos);
  };

  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <>
      <Autocomplete
        onLoad={(ref) => (autocompleteRef.current = ref)}
        onPlaceChanged={onPlaceChanged}
      >
        <input
          type="text"
          placeholder="Search location"
          style={{
            width: "90%",
            height: "40px",
            marginBottom: "10px",
            padding: "0 10px",
            fontSize: "16px",
          }}
        />
      </Autocomplete>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={14}
        onClick={onMapClick}
      >
        {markerPosition && (
          <Marker
            position={markerPosition}
            draggable
            onDragEnd={onMarkerDragEnd}
          />
        )}
      </GoogleMap>
    </>
  );
}

export default MapWithDraggableMarker;
